// const product_host = 'https://banama.njzb.vip'; // 测试环境域名  
const product_host = 'https://zkxa.zhyich.com'; //生产环境域名

let baseURL = `${product_host}/api/`;
let uploadImgUrl = `${product_host}/api/v1/5d5fa8984f0c2`;
export {
    product_host,
    baseURL,
    uploadImgUrl,
}